export default __webpack_public_path__ + "static/media/copy_menu_icon.73ae9138.svg";